export default "__VITE_ASSET__9tQjRl8S__"